import React from 'react';
import { Box } from '../components/design/Box';

export const NotFound = () => <Box>Site not found</Box>;
